import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, List, Modal, Popconfirm, Skeleton, Typography } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import AddEditVersion from "./AddEditVersion";
import { DeleteVersion, GetVersionBySoftwareId } from "../../../API/api";
import { enqueueSnackbar } from "notistack";

interface VersionManagementType {
    softwareId:number;
    handleCloseVersion: (data: boolean) => void;

  }



  const VersionManagement: React.FC<VersionManagementType> = ({ softwareId,handleCloseVersion }) => {
    const [isLoading,setIsLoading] = useState<boolean>(false)
    const [isOpen,setIsOpen] = useState<boolean>(true)
    const [isOpenAddEditVersion,setIsOpenAddEditVersion] = useState<boolean>(false)
    const [editData,setEditData] = useState({})
    const [isEdit,setIsEdit] = useState<boolean>(false)
    const onClosePopup = () => {setIsOpen(false); handleCloseVersion(true)}
    const deleteVersion = (deleteRow:any) => {
      setIsLoading(true)
      DeleteVersion(softwareId,deleteRow.versionId)
                  .then((response:any)  =>  {
                    enqueueSnackbar("Deleted Successfully", {
                      variant: "success",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });

                    setIsLoading(false)
                    getVersionBySoftwareId()
                  })
                  .catch((error:any)  =>  {
                  
                    enqueueSnackbar("Error in deleting", {
                      variant: "error",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });
                    setIsLoading(false)

                  })
    
    
    }
    const [versionList,setVersionList] = useState([])
    const [softwareName,setSoftwareName] = useState<string>("")
    const [companyName,setCompanyName] = useState<string>("")

    useEffect(()=>{
      getVersionBySoftwareId()
    },[])

const getVersionBySoftwareId = async () => {
    try {
      setIsLoading(true)
      const response = await GetVersionBySoftwareId(softwareId);
      const newData = response.data.versions.map((version: any, index: number) => ({
        ...version,
        key: version.softwareId,
      })
      );
      setSoftwareName(response.data.softwareName)
      setCompanyName(response.data.companyName)
      setVersionList(newData)
      setIsLoading(false)

    } catch (error) {
      setIsLoading(false)

    }
}

    const handleEditVersion = (rowData:any) => {
      setIsEdit(true)
        setEditData(rowData)
        setIsOpen(false)
        setIsOpenAddEditVersion(true)
      }
      const openAddVersion = () =>{
        setIsEdit(false)
        setIsOpen(false)
        setEditData({})
        setIsOpenAddEditVersion(true)
      }

      const handleClosePopup = (isReload:boolean) => {
        setIsOpenAddEditVersion(false);
        if(isReload)
        getVersionBySoftwareId()
        setIsOpen(true)
      }
    return (
        <>
        <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" /></Backdrop>
      { !isOpenAddEditVersion &&   
       <Modal
                maskClosable={false}
                footer={null}
                title='Version Management'
                onCancel={onClosePopup}
                open={isOpen}
              > 
        
          <strong>Software Name: </strong>
          {softwareName}
          <br />
          <strong>Company: </strong>
          {companyName}
    <div className="modal-list-wrapper">

    <List
            className="demo-loadmore-list"
            itemLayout="horizontal"
            dataSource={versionList}
            renderItem={(item: any, index) => (
              <List.Item
                actions={[
                
                  <>
                  <Typography.Link
            onClick={() => handleEditVersion(item)
            }
          >
            {" "}
            <EditOutlined />
          </Typography.Link> 
                 <Popconfirm
                    title="Do you want to remove the version?"
                    onConfirm={() => deleteVersion(item)}
                  >
                    <a> <DeleteOutlined /></a>
                  </Popconfirm></>,
                ]}
              >
                <Skeleton avatar title={false} loading={item.loading} active>
               {item.version}
                
                </Skeleton>
              </List.Item>
            )}
          />
                <Button onClick={openAddVersion} className="pm-btn" type="primary">Add Version</Button>

    </div>
          </Modal>}
 


         {isOpenAddEditVersion && <AddEditVersion handleClosePopup={handleClosePopup} editData={editData} isEdit={isEdit} softwareId={softwareId}/>} 
        </>
      );
}

export default VersionManagement;